module.exports = __webpack_public_path__ + "static/media/orbitalinsight_image.82121686.png";